export default __webpack_public_path__ + "static/imgTyrepng-f866f4a3ff06c0c431062c57f24c1226.png";